import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import "./sass/App.scss";

// import { MenuBar } from "./components/MenuBar";
// import { Navbar } from "./components/Navbar";
// import { Hero } from "./components/Hero";
// import { NewsSection } from "./components/NewsSection";
// import { ArticlesSection } from "./components/ArticlesSection";
// import { TvSection } from "./components/TvSection";
// import { Partidos } from "./components/Partidos";
// import { Diapositivas } from "./components/Diapositivas";
import { Footer } from "./components/Footer";
import { HomePage } from "./components/HomePage";
import { FemPage } from "./components/FemPage";
import Layout from "./components/Layout";
// import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
function App() {
  return (
    <div className="app-container">
      <Router>
        <Layout>
          <Routes>
            {/* Define a route for the root path '/' */}
            <Route path="/" element={<HomePage />} />
            <Route path="/Footer" element={<Footer />} />
            <Route path="/FemPage" element={<FemPage />} />
            {/* Define other routes for different paths */}
            {/* For example: */}
            {/* <Route path="/news" element={<NewsPage />} /> */}
          </Routes>
        </Layout>
      </Router>
    </div>
  );
}

export default App;
